module.exports = __webpack_public_path__ + "img/icon_pause_3.1b6fa8ba.svg";